import * as React from "react";

import { useDateFormatter } from "@/hooks/useDateFormatter";

interface Props {
  month: string;
  partialMonth: boolean;
  lastInvoiceDate: string | null;
  droppedMissingRateCount: number;
  children: React.ReactNode;
}

/** The data-quality notes every report shows above its figures. */
export const ReportNotes = ({ month, partialMonth, lastInvoiceDate, droppedMissingRateCount, children }: Props) => {
  const { formatDate } = useDateFormatter();
  const [year, monthNumber] = month.split("-").map(Number);
  const monthEnd = new Date(Date.UTC(year, monthNumber, 0)).toISOString().slice(0, 10);
  return (
    <section
      aria-label="Report notes"
      className="space-y-1 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900"
    >
      {partialMonth && lastInvoiceDate ? (
        <p>
          <strong>Month is partial:</strong> invoices run to {formatDate(lastInvoiceDate)}, the month ends{" "}
          {formatDate(monthEnd)}.
        </p>
      ) : null}
      {children}
      {droppedMissingRateCount ? (
        <p>{droppedMissingRateCount} transactions this month have no exchange rate and are left out.</p>
      ) : null}
    </section>
  );
};
